import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ComponentsCommunicationService } from 'src/app/services/components-communication.service';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationDialogComponent } from 'src/app/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { ResultObservationsAttachmentsComponent } from '../dialogs/result-observations-attachments/result-observations-attachments';
import { ApiResultsService } from 'src/app/services/api.results.service';

@Component({
  selector: 'app-result-observations-observations',
  templateUrl: './result-service-observations.component.html',
  styleUrls: ['./result-service-observations.component.scss']
})
export class ResultServiceObservationsComponent {
  observationsUpdate!: Subscription;
  @Input() element:any;
  displayedColumns: string[] = ['title', 'description', 'actions'];
  showActions = false;
  isLoading = false;
  noResults = false;
  addNewEnabled = false;
  taskId: any;
  dataSource: any = [];
  constructor(
    private snackBar: MatSnackBar,
    private componentsCommunication: ComponentsCommunicationService,
    private dialog: MatDialog,
    private apiResultsService: ApiResultsService) {}

  ngOnInit() {      
   
    this.observationsUpdate = this.componentsCommunication.getUpdatedList().subscribe(name => {
      // updates the list
      if(name == 'update_results_observations') {
        this.getData();
      }
    }); 
    if (this.element.id) {
      this.getData();
    } else {
      console.log('no id detected');
    }
    
  }
  ngOnDestroy() {
    this.observationsUpdate.unsubscribe();
  }

  preview(element: any){}

  getData() {
    this.isLoading = true;
    const tenantId = localStorage.getItem('taskTenantId');   
    const workareaId = localStorage.getItem('taskWorkareaId');     
    const params = {
      workareaId: workareaId && workareaId.length > 0 ? workareaId : '',
      tenantId: tenantId && tenantId.length > 0 ? tenantId : '',
      datapointValueId: this.element.id      
    }

    //Get list DataPoint Catalog Observations 
    this.apiResultsService.getDatapointCatalogObservations(params).subscribe(
      (result: any) => {
        if(result) {
          this.isLoading = false;
          this.dataSource = result;
        } else {
          this.dataSource = [];
        }
      },
      // error
      (msg) => {       
        this.isLoading = false; 
        console.log('error retrieving data from endpoint ' + msg.error);
    });
  }
  
  addNew(action: string) {
    const tenantId = localStorage.getItem('taskTenantId');
    const params = {
      tenantId: tenantId && tenantId.length > 0 ? tenantId : '',   
      taskId: this.taskId,
      element: this.element,
      action: action
    }
    //service_observations
    this.dialog.open(ResultObservationsAttachmentsComponent, {
      height: 'auto',
      width: '400px',
      disableClose: true,
      data: params
    });
  }

  editDetails (element: any) {
    const tenantId = localStorage.getItem('taskTenantId');
    const params = {
      tenantId: tenantId && tenantId.length > 0 ? tenantId : '',  
      taskId: this.taskId,
      action: 'update_observation',
      element: this.element,
      selectedElement: element
    }      

    this.dialog.open(ResultObservationsAttachmentsComponent, {
      height: 'auto',
      width: '400px',
      disableClose: true,
      data: params
    });
  }

  confirmation(action: string, elem?: any) {    
    elem.action = action;
    elem.confirmation = false;
    if (action == 'delete') {
      elem.confirmationString = 'Delete the selected element?';
    } 
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      height: '200px',
      width: '440px',
      disableClose: true,
      autoFocus: false,
      data: elem
    });

    dialogRef.afterClosed().subscribe(
      (data) => {
        if (data.confirmation) {
          this.deleteElem(elem);
        }
      }
    ); 
  }

  /**
   * deletes the selected service from the list
   * @param element selected element to be removed
   */
  deleteElem(element: any){
    const tenantId = localStorage.getItem('taskTenantId');   
    const workareaId = localStorage.getItem('taskWorkareaId');     
    const params = {
      workareaId: workareaId && workareaId.length > 0 ? workareaId : '',
      tenantId: tenantId && tenantId.length > 0 ? tenantId : '',
      hashName: element.hash,
      observableId: element.id
    }
  
    //api/task/observations/{tenantId}/deleteObservation/{obs_id} 
    this.apiResultsService.deleteResultObservation(params).subscribe(
      (result) => {
        console.log( 'Element deleted');
        this.snackBar.open( 'Element deleted ', '', {duration: 3000});
        // sends an update
        this.componentsCommunication.setUpdateList('update_results_observations');
    },
      // error
      (msg) => {
        if (msg.status == '200') {
          console.log( 'Element deleted');
          this.snackBar.open( 'Element deleted ', '', {duration: 3000});
          // sends an update
          this.componentsCommunication.setUpdateList('update_results_observations');
        }
        console.log( msg.statusText);
    }); 
    }
}
